<div class="itineraryBox_wrapper">

  <div class="accomodation_wrapper">
  <div id="b_container"></div>
  <div #script_container></div>
  </div>
</div>